import { Card } from "primereact/card";
import React, { useState } from "react";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import AddModel from "./sub_modules/add_model/add_model";
import { Dropdown } from "primereact/dropdown";
import { csrequirmentphonetype, status } from "./assets";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
export default function ManageModelFlowPage() {
  const formik = useFormik({
    initialValues: {
      model: "",
      modelid: "",
      csrequirmentphonetype: "",
      status: "",
    },
  });
  const [navigatetoaddmodel, setNavigateToAddModel] = useState(false);
  function downloadList() {}
  return (
    <>
      {navigatetoaddmodel ? (
        <AddModel agent={""} setNavigateToAddModel={setNavigateToAddModel} />
      ) : (
        <Card>
          <div className="card flex flex-wrap justify-content-between">
            <div>
              <h5> Model List</h5>
            </div>
            <div>
              <Button
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  padding: "0rem",
                }}
              >
                <i
                  className="pi pi pi-download"
                  onClick={() => {
                    downloadList();
                  }}
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "1.4rem",
                    color: "#fff",
                    padding: "0.5rem",
                    cursor: "pointer",
                    paddingLeft: "1rem",
                    borderRadius: "0.5rem",
                    paddingRight: "1rem",
                    background: "#00c0ef",
                  }}
                ></i>
              </Button>
              <Button
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  padding: "0rem",
                }}
              >
                <i
                  className="pi pi pi-plus"
                  onClick={() => {
                    setNavigateToAddModel((prev) => !prev);
                  }}
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "1.4rem",
                    color: "#fff",
                    padding: "0.5rem",
                    cursor: "pointer",
                    paddingLeft: "1rem",
                    borderRadius: "0.5rem",
                    paddingRight: "1rem",
                    background: "#00c0ef",
                  }}
                ></i>
              </Button>
            </div>
          </div>
          <Card>
            <div className="flex justify-content-around flex-wrap">
              <div className="w-20rem mt-4">
                <label style={{ display: "block" }}>Make/Model</label>
                <Button
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                    padding: "0rem",
                  }}
                >
                  <i
                    className="pi pi pi-mobile"
                    onClick={() => {
                      setNavigateToAddModel((prev) => !prev);
                    }}
                    style={{
                      display: "inline-block",
                      marginLeft: "0.5rem",
                      fontSize: "1.4rem",
                      color: "#fff",
                      padding: "1.2rem",
                      borderRight: "unset",
                      cursor: "pointer",
                      paddingLeft: "1rem",
                      borderRadius: "0rem",
                      paddingRight: "1rem",

                      border: "solid rgb(206, 212, 218) 1px",
                    }}
                  ></i>
                </Button>
                <InputText
                  className=" mt-2 "
                  style={{ display: "inline-block", borderRadius: "0rem" }}
                  onChange={(e) => {
                    formik.setFieldValue("model", e.value);
                  }}
                  placeholder="Example: Search By Make/model"
                  value={formik.values.model}
                />
              </div>
              <div className="w-20rem mt-4">
                <label style={{ display: "block" }}>Model ID</label>
                <i
                  className="pi pi pi-mobile"
                  onClick={() => {
                    setNavigateToAddModel((prev) => !prev);
                  }}
                  style={{
                    display: "inline-block",
                    marginLeft: "0.5rem",
                    fontSize: "1.4rem",
                    color: "#fff",
                    padding: "1.2rem",
                    borderRight: "unset",
                    cursor: "pointer",
                    paddingLeft: "1rem",
                    borderRadius: "0rem",
                    paddingRight: "1rem",

                    border: "solid rgb(206, 212, 218) 1px",
                  }}
                ></i>
                <InputText
                  className="mt-2"
                  style={{ borderRadius: "0rem" }}
                  onChange={(e) => {
                    formik.setFieldValue("modelid", e.value);
                  }}
                  placeholder="Example: 12345..."
                  value={formik.values.modelid}
                />
              </div>
              <div className="w-20rem mt-4">
                <label style={{ display: "block" }}>
                  CSR Equipment Phone Type
                </label>

                <i
                  className="pi pi pi-eye"
                  style={{
                    display: "inline-block",
                    marginLeft: "0.5rem",
                    fontSize: "1.4rem",
                    color: "#fff",
                    padding: "1.2rem",
                    borderRight: "unset",
                    cursor: "pointer",
                    paddingLeft: "1rem",
                    borderRadius: "0rem",
                    paddingRight: "1rem",

                    border: "solid rgb(206, 212, 218) 1px",
                  }}
                ></i>
                <Dropdown
                  options={csrequirmentphonetype}
                  style={{ borderRadius: "0rem" }}
                  className=" w-16rem mt-2"
                  onChange={() => {
                    formik.setFieldValue("csrequirmentphonetype");
                  }}
                  value={formik.values.csrequirmentphonetype}
                  placeholder="Select An option"
                />
              </div>
              <div className="w-20rem mt-4">
                <label style={{ display: "block" }}>Status</label>
                <i
                  className="pi pi pi-copy"
                  style={{
                    display: "inline-block",
                    marginLeft: "0.5rem",
                    fontSize: "1.4rem",
                    color: "#fff",
                    padding: "1.2rem",
                    borderRight: "unset",
                    cursor: "pointer",
                    paddingLeft: "1rem",
                    borderRadius: "0rem",
                    paddingRight: "1rem",

                    border: "solid rgb(206, 212, 218) 1px",
                  }}
                ></i>
                <Dropdown
                  className="w-16rem mt-2"
                  style={{ borderRadius: "0rem" }}
                  options={status}
                  onChange={(e) => {
                    formik.setFieldValue("status");
                  }}
                  value={formik.values.status}
                  placeholder="Select An option"
                />
              </div>
            </div>
            <div className="mt-4 flex flex-wrap justify-content-center">
              <Button label="Search" />
            </div>
            <div style={{ overflowY: "auto" }} className="mt-4">
              <DataTable style={{ minWidth: "300rem" }}>
                <Column header="#" />
                <Column header="Action" />
                <Column header="Make Model ID" />
                <Column header="Make" />
                <Column header="Model" />
                <Column header="Model Number" />
                <Column header="Amount" />
                <Column header="Network Type" />
                <Column header="SIM Type" />
                <Column header="FCC ID" />
                <Column header="HAC" />
                <Column header="Wifi" />
                <Column header="Data" />
                <Column header="OS" />
                <Column header="Status" />
                <Column header="Grade" />
                <Column header="M Rating" />
                <Column header="T Rating" />
                <Column header="Voice Only" />
                <Column header="SKU" />
                <Column header="Hotspot Capable" />
                <Column header="CSR Equipment Phone Type" />
                <Column header="HandOver" />
                <Column header="Created Date" />
                <Column header="Created By" />
                <Column header="Updated By" />
                <Column header="Updated Date" />
              </DataTable>
            </div>
          </Card>
        </Card>
      )}
    </>
  );
}
